import { useEffect, useState } from "react";
import assets from "./assets/assetManifest";

function getAssetType(url) {
  try {
    const cleanUrl = url.split("?")[0];

    if (cleanUrl.includes("/video/")) return "video";
    if (cleanUrl.includes("/audio/")) return "audio";

    // fallback by extension (Cloudinary may still keep it)
    const ext = cleanUrl.split(".").pop().toLowerCase();

    if (["mp4", "webm"].includes(ext)) return "video";
    if (["mp3", "wav", "ogg"].includes(ext)) return "audio";

    return "image";
  } catch {
    return "image";
  }
}

export default function useLoadingProgress() {
  const [steps, setSteps] = useState({
    fonts: false,
    assets: false,
    tools: false,
    missions: false,
  });

  useEffect(() => {
    /* ---------- Fonts ---------- */
    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        setSteps(s => ({ ...s, fonts: true }));
      });
    } else {
      setSteps(s => ({ ...s, fonts: true }));
    }

    /* ---------- Cloudinary Assets ---------- */
    const loadAsset = (url) =>
      new Promise((resolve, reject) => {
        const type = getAssetType(url);

        if (type === "video") {
          const video = document.createElement("video");
          video.src = url;
          video.preload = "auto";
          video.onloadeddata = resolve;
          video.onerror = reject;
        } 
        else if (type === "audio") {
          const audio = new Audio();
          audio.src = url;
          audio.preload = "auto";
          audio.oncanplaythrough = resolve;
          audio.onerror = reject;
        } 
        else {
          const img = new Image();
          img.src = url;
          img.onload = resolve;
          img.onerror = reject;
        }
      });

    Promise.allSettled(assets.map(loadAsset)).then(() => {
      setSteps(s => ({ ...s, assets: true }));
    });

    /* ---------- Tools (Lazy Modules) ---------- */
    Promise.all([
      import("./components/Gallery"),
      import("./components/Projects"),
      import("./components/Techstack"),
    ]).then(() => {
      setSteps(s => ({ ...s, tools: true }));
    });

    /* ---------- Missions (Narrative / UX delay) ---------- */
    const timer = setTimeout(() => {
      setSteps(s => ({ ...s, missions: true }));
    }, 800);

    return () => clearTimeout(timer);
  }, []);

  return steps;
}
